import { Fragment, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/hooks";
import { authSelector } from "src/modules/auth/redux/authSlice";
import { useIdle } from "react-use";
import Navbar from "../Navbar";
import LoginModal from "src/modules/auth/components/LoginModal";
import API from "src/redux/api";

const DashboardLayout = () => {
    var dispatch = useAppDispatch();
    var { token } = useAppSelector(authSelector);
    const isIdle = useIdle(90e4); // 15mins

    // refetch config and user profile if idle for more than 15mins
    useEffect(() => {
        if (token && isIdle) {
            dispatch(
                API.util.invalidateTags([
                    "config",
                    "onDemandUser",
                    "rider",
                ] as any)
            );
        }
    }, [isIdle, token, dispatch]);
    return (
        <Fragment>
            <Navbar />
            <Outlet />
            <LoginModal />
        </Fragment>
    );
};

export default DashboardLayout;
